import { trackPromise } from "react-promise-tracker";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/v1` : 'http://localhost:8001';

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'ngrok-skip-browser-warning': 'any',
        'Access-Control-Allow-Origin': '*'
    };
};

const handleResponse = (res) => {
    if (res.status === 200 || res.status === 201) {
        return res.data;
    }
    throw res;
};

const apiCall = (method) => async (endpoint, data = null) => {
    return trackPromise(
        axios({
            method,
            url: `${BASE_URL}/${endpoint}`,
            data,
            headers: getHeaders()
        })
            .then(handleResponse)
            .catch((err) => { throw err; })
    );
};

export const GET_API = apiCall('get');
export const POST_API = apiCall('post');
export const PUT_API = apiCall('put');
export const DELETE_API = apiCall('delete');